<template>
  <v-container v-if="RBAC_role_EDIT_ROLE && RBAC_role_GRANT_ROLE">
    <base-material-card :renderCard="card" color="secondary" icon="mdi-key-outline" :title="$t('edit_roles')">
      <v-container>
        <v-row v-if="listRole && listRole.length > 0">
          <v-col cols="12">
            <v-combobox v-model="selectedRoleObj" :items="listRole" item-text="dex" item-value="code" dense
              :label="$t('select_create_role')"></v-combobox>
          </v-col>
        </v-row>
        <v-row v-if="selectedRole">
          <v-col cols="12">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel :v-if="selectedRole && roleData && roleData.modules" v-for="role in roleData.modules"
                v-bind:key="role.code" class="mr-3">
                <v-expansion-panel-header>
                  <v-row no-gutters style="width: 100%">
                    <v-col cols="6">{{ role.dex }}</v-col>
                    <v-col cols="6">
                      {{
                        role.permission.filter((perm) => {
                          return perm.perm;
                        }).length
                      }}
                      / {{ role.permission.length }}
                      <v-progress-linear color="primary" :value="
                        (role.permission.filter((perm) => {
                          return perm.perm;
                        }).length *
                          100) /
                        role.permission.length
                      "></v-progress-linear>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container>
                    <v-row>
                      <v-col :v-if="role && role.permission" md="2" cols="6" v-for="perm in role.permission"
                        v-bind:key="perm.code">
                        <v-checkbox :disabled="selectedRole === 'root'" :false-value="false" :true-value="true"
                          v-model="perm.perm" :label="perm.dex"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <v-col cols="12" class="text-center">
            <v-btn class="mx-5" v-if="selectedRole !== 'root' && method" @click="saveRole" color="success">{{ method ===
              "NEW" ? $t("create") : $t("save") }}</v-btn>
            <v-btn class="mx-5" v-if="roleData.canDelete && method === 'EDIT'" @click="deleteRole" color="error">{{
              $t("delete") }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "edit-role",
  components: {},
  props: {
    card: false,
    role: null,
  },
  data() {
    return {
      RBAC_role_EDIT_ROLE: false,
      RBAC_role_GRANT_ROLE: false,
      panel: [],
      method: null,
      selectedRoleObj: null,
      roleData: { modules: null },
      listRole: [],
    };
  },
  computed: {
    selectedRole: function () {
      if (this.selectedRoleObj && this.selectedRoleObj.code)
        return this.selectedRoleObj.code;
      else return this.selectedRoleObj;
    },
  },
  watch: {
    role: function (newVal, oldVal) {
      // watch it
      this.selectedRoleObj = newVal;
    },
    selectedRole: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadData();
    },
  },
  created() {
    if (this.role) this.selectedRoleObj = this.role;
    else this.selectedRoleObj = "root";
    this.loadData();
  },
  methods: {
    loadData() {
      let _ = this;

      _.roleData = { modules: null };
      _.method = null;
      _.RBAC_role_EDIT_ROLE = this.checkUserRole("role", "EDIT_ROLE");
      _.RBAC_role_GRANT_ROLE = this.checkUserRole("role", "GRANT_ROLE");
      if (_.selectedRole) {
        _.chiamataAxios("GET", "/auth/portal/getRole/" + _.selectedRole).then(
          (response) => {
            _.roleData = response.data;
            _.panel = null;
          }
        );
      }
      _.listRole = null;
      _.chiamataAxios("GET", "/auth/portal/listRole").then((response) => {
        _.listRole = response.data.map((ruolo) => {
          if (!ruolo.canAssign) ruolo.dex = "* " + ruolo.dex + " *";
          return ruolo;
        });
        _.method = "NEW";
        if (
          _.listRole.filter((ruolo) => {
            return ruolo.code === _.selectedRole;
          }).length > 0
        )
          _.method = "EDIT";
      });
    },

    saveRole() {
      let _ = this;
      this.chiamataAxios("POST", "/auth/portal/saveRole/" + _.selectedRole, {
        body: _.roleData.modules,
      }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.loadData();
        }
      });
    },
    deleteRole() {
      let _ = this;
      this.chiamataAxios(
        "DELETE",
        "/auth/portal/deleteRole/" + _.selectedRole,
        { body: _.roleData }
      ).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>"
          Swal.fire({
            type: "success",
            html: html,
          });
          _.selectedRole = null;
          _.loadData();
        }
      });
    },
  },
};
</script>